import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label"]

  connect() {
    this.control = this.element.closest("[data-public-signup-control]")
    this.container = this.control.parentElement
    this.observer = new ResizeObserver(() => this.fit())
    const observedElements = [this.container, this.element, this.labelTarget, this.control]
    observedElements.forEach((element) => this.observer.observe(element))
    this.fit()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  fit() {
    const decline = this.labelTarget.parentElement
    if (!decline.getClientRects().length || decline.classList.contains("hidden")) {
      this.control.classList.remove("public-invitation-status-hidden")
      return
    }

    const compact = this.element.classList.contains("public-invitation-actions--compact")
    // The hidden label stays measurable so widening restores it without flicker.
    const labelWidth = this.labelTarget.getBoundingClientRect().width
    const gap = parseFloat(getComputedStyle(decline).columnGap) || 0
    const declineStyle = getComputedStyle(decline)
    const naturalDeclineWidth = labelWidth + gap + decline.querySelector("i").getBoundingClientRect().width +
      parseFloat(declineStyle.paddingLeft) + parseFloat(declineStyle.paddingRight) +
      parseFloat(declineStyle.borderLeftWidth) + parseFloat(declineStyle.borderRightWidth)
    const fullWidth = this.element.getBoundingClientRect().width +
      (compact ? Math.max(0, naturalDeclineWidth - decline.getBoundingClientRect().width) : 0)
    // Status yields space before either answer. Wrapped badges never reduce the
    // width available to the action row.
    const availableWidth = this.container.clientWidth
    const status = this.control.querySelector("[data-public-invite-status]")
    const statusWidth = status?.getBoundingClientRect().width || 0
    this.control.classList.toggle("public-invitation-status-hidden", fullWidth + statusWidth + 8 > availableWidth)
    this.element.classList.toggle("public-invitation-actions--compact", fullWidth > availableWidth + 1)
  }
}
